/* Encanto mobile footer: menu columns become accordions on phones, and the floating
   widgets (back to top, language button) step aside while the footer is on screen.
   Desktop (768px and up) is untouched. Without JavaScript every column stays open. */
(function () {
  var phone = window.matchMedia('(max-width: 767px)');

  function footerRoot() { return document.getElementById('t4s-footer'); }

  // Columns are tagged by sections/footer.liquid; older markup is tagged here as a fallback.
  function tagColumns(footer) {
    footer.querySelectorAll('.t4s-footer-wrap > .t4s-custom-col').forEach(function (col, i) {
      if (col.hasAttribute('data-enc-foot') || col.classList.contains('enc-foot-social-mb')) return;
      if (col.querySelector('.t4s-newsletter-parent')) col.setAttribute('data-enc-foot', 'newsletter');
      else if (col.querySelector('.t4s-footer-menu')) col.setAttribute('data-enc-foot', 'menu');
      else if (i === 0 || col.querySelector('.enc-foot-logo')) col.setAttribute('data-enc-foot', 'brand');
    });
    // Social icons move to the end on phones when the section did not render the mobile row.
    if (phone.matches && !footer.querySelector('.enc-foot-social-mb')) {
      var social = footer.querySelector('.t4s-footer-wrap .t4s-socials-block');
      var wrap = footer.querySelector('.t4s-footer-wrap');
      if (social && wrap) {
        var row = document.createElement('div');
        row.className = 't4s-custom-col t4s-col-item t4s-col-12 enc-foot-social-mb enc-foot-social-mb--moved';
        row.innerHTML = '<div class="t4s-col-inner t4s-text-start"><div class="t4s-footer-content"></div></div>';
        row.querySelector('.t4s-footer-content').appendChild(social);
        wrap.appendChild(row);
      }
    }
  }

  function setupAccordions(footer) {
    footer.querySelectorAll('.t4s-custom-col[data-enc-foot="menu"]').forEach(function (col, i) {
      if (col.getAttribute('data-enc-acc') === 'true') return;
      var head = col.querySelector('.t4s-footer-heading-mobile');
      var panel = col.querySelector('[data-footer-content]');
      if (!head || !panel) return;
      col.setAttribute('data-enc-acc', 'true');
      var id = panel.id || 'enc-foot-panel-' + (i + 1);
      panel.id = id;
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-controls', id);

      function setOpen(open) {
        col.classList.toggle('is--footer_opened', open);
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      }
      function sync() {
        if (phone.matches) {
          if (!col.classList.contains('enc-foot-acc')) { col.classList.add('enc-foot-acc'); setOpen(false); }
        } else {
          col.classList.remove('enc-foot-acc', 'is--footer_opened');
          head.removeAttribute('aria-expanded');
          panel.removeAttribute('aria-hidden');
        }
      }
      head.addEventListener('click', function (event) {
        // Kalles binds its own slideToggle to [data-footer-open] after a resize; keep one behaviour.
        event.stopImmediatePropagation();
        if (!phone.matches) return;
        setOpen(!col.classList.contains('is--footer_opened'));
      });
      head.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); head.click(); }
      });
      sync();
      if (phone.addEventListener) phone.addEventListener('change', sync); else phone.addListener(sync);
    });
    // The newsletter heading is a plain title on phones; swallow the theme's toggle if it ever binds.
    footer.querySelectorAll('.t4s-custom-col[data-enc-foot="newsletter"] [data-footer-open]').forEach(function (head) {
      head.addEventListener('click', function (event) { event.stopImmediatePropagation(); });
    });
  }

  // While the footer (and especially the email field) is on screen, the fixed widgets hide so
  // nothing covers the form or the links. Classes are read by encanto-footer.css on phones only.
  function watchFooter(footer) {
    if (!('IntersectionObserver' in window)) return;
    var html = document.documentElement;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { html.classList.toggle('enc-footer-in-view', entry.isIntersecting); });
    }, { threshold: 0 }).observe(footer);
    var field = footer.querySelector('.t4s-newsletter__inner');
    if (field) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { html.classList.toggle('enc-footer-form-in-view', entry.isIntersecting); });
      }, { threshold: 0.2 }).observe(field);
    }
  }

  function init() {
    var footer = footerRoot();
    if (!footer || footer.getAttribute('data-enc-foot-ready') === 'true') return;
    footer.setAttribute('data-enc-foot-ready', 'true');
    tagColumns(footer);
    setupAccordions(footer);
    watchFooter(footer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('#t4s-footer')) {
      event.target.querySelector('#t4s-footer').removeAttribute('data-enc-foot-ready');
      init();
    }
  });
})();
